import React, { FC } from 'react';
import { StyleSheet, View } from 'react-native';
import { Defs, RadialGradient, Rect, Stop, StopProps, Svg } from 'react-native-svg';

import { Theme } from '@constants';

import { useGradientProps } from './helpers';
import { styles } from './styles';

const defaultColorList: StopProps[] = [
  { offset: '0%', stopColor: Theme.gradients.loading.start, stopOpacity: '1' },
  { offset: '100%', stopColor: Theme.gradients.loading.end, stopOpacity: '1' },
];

export const TWCRadialGradient: FC<TWCRadialGradientProps> = ({
  children,
  colorList = defaultColorList,
  resize = 'center',
}) => {
  const gradientProps = useGradientProps(resize);

  return (
    <View style={styles.radialGradient}>
      <View style={{ ...StyleSheet.absoluteFillObject }}>
        <Svg height="100%" width="100%">
          <Defs>
            <RadialGradient id="grad" cx="50%" cy="50%" {...gradientProps}>
              {colorList.map((value, index) => (
                <Stop key={`RadialGradientItem_${index}`} {...value} />
              ))}
            </RadialGradient>
          </Defs>
          <Rect x="0" y="0" width="100%" height="100%" fill="url(#grad)" />
        </Svg>
      </View>
      {children}
    </View>
  );
};

type TWCRadialGradientProps = {
  resize?: 'cover' | 'center';
  colorList?: StopProps[];
};
